import React, { useEffect, useState } from 'react';
import { API } from '../backend';
import { useFlutterwave } from 'flutterwave-react-v3';

import Layout from '../../reusables/layout/layout';
import RequsitionModel from '../../Component/requisitionforms/requisitionModel';
import { useSelector } from 'react-redux';

const Model = () => {

    const token = useSelector((state) => state?.user?.data?.token);



    return (
        <div>
            <Layout>
                {token &&
                    <RequsitionModel examType={'MODEL SCREENING EXAMINATION'} examName={'Model/Screening College'} />

                }
                {/* <ProceedModalPrint pin={pinNum} open={open} handleClose={handleClose} /> */}
            </Layout>
        </div>
    );
};

export default Model;
